/** @jsxImportSource react */
/** @jsxFactory React.createElement */
/** @jsxFragmentFactory React.Fragment */

import { useEffect, useRef } from 'react';
import { InteractionConfig } from './types';

export default function Interaction(props: {
	shouldPlay: boolean;
	config: InteractionConfig;
	onLoaded: () => void;
	onDone: () => void;
	onError: (e: Error) => void;
}) {
	const { config, onDone, onLoaded, shouldPlay } = props;

	const audio = useRef<HTMLAudioElement>(null);
	useEffect(() => {
		if (!shouldPlay) return;
		audio.current!.volume = config.volume || audio.current!.volume;
		audio.current!.play();
	}, [config.volume, shouldPlay]);

	return (
		<div className={`relative h-[100vh] w-[100vw] transition-opacity duration-[3000ms] ${shouldPlay ? 'opacity-100' : 'opacity-0'}`}>
			<img src={config.img} alt="a masterpiece" className="h-full w-full object-contain" />
			<p
				className={`absolute left-2/3 -top-4 -rotate-6 px-4 py-8 text-2xl rounded-b-xl shadow-lg shadow-gray-700 font-semibold border-2 ${
					config.BuyerInfo?.['has-plus'] ? 'bg-gray-800 text-orange-200/70 border-gray-700' : 'bg-gray-100 border-gray-300 text-gray-900'
				}`}
			>
				By: {config.BuyerInfo ? <tangia-plus-name-badge {...config.BuyerInfo}>{config.from}</tangia-plus-name-badge> : config.from}
			</p>
			<audio src="/sound.mp3" preload="auto" ref={audio} onCanPlayThrough={onLoaded} onEnded={() => setTimeout(onDone, config.timeout)} autoPlay={shouldPlay} />
		</div>
	);
}
